import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { format, parseISO } from 'date-fns';
import ModalConfirm from '../../../../components/ModalConfirm';
import { JdsTag } from '../../../../components/jds/JdsTag';
import { JdsButton } from '../../../../components/jds/JdsButton';
import '../../../../components/jds/jds.css';
import { CouponStatusBadge } from '../_components/CouponStatusBadge';
import { CouponDiscountsTable } from '../_components/CouponDiscountsTable';
import { useCouponDetailsBootstrap } from './coupon-details.bootstrap.hook';
import { CouponTypeEnum } from '../../../../api/payments/coupons/domain/enum';
import { CouponTypeLabels } from '../../../../api/payments/coupons/domain/labels';
import { JdsMoreToggle } from '../../../../components/jds/JdsMoreToggle';

function formatDate(value) {
  if (!value) return '-';
  return format(parseISO(value), 'dd/MM/yyyy');
}

function DetailRow({ label, children }) {
  return (
    <div className="jds-detail-row">
      <span className="text-muted">{label}</span>
      <span style={{ textAlign: 'right' }}>{children}</span>
    </div>
  );
}

export default function CouponDetailsV2(props) {
  const couponId = props.match.params.id;
  const {
    coupon,
    confirmAction,
    setConfirmAction,
    loading,
    fetchingCoupon,
    goToEdit,
    goToList,
    handleExpire,
    handleDelete,
  } = useCouponDetailsBootstrap(couponId, props.location.state?.coupon);

  const discounts = coupon?.rules ?? [];

  if (!coupon) {
    return (
      <div className="jds-scope">
        <span>
          {fetchingCoupon
            ? 'Carregando dados do cupom...'
            : 'Não foi possível carregar os dados do cupom. Volte para a listagem e tente novamente.'}
        </span>
      </div>
    );
  }

  return (
    <div className="jds-scope">
      <div className="mb-5">
        <span
          role="button"
          tabIndex={0}
          onClick={goToList}
          className="text-muted"
          style={{ cursor: 'pointer' }}
        >
          &lt; Painel ADMIN
        </span>
        <span className="text-muted"> &bull; Cupons JusSub</span>
      </div>

      <div className="jds-card mb-6">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ marginBottom: 'var(--space-24)' }}
        >
          <h1 className="jds-title-md">Detalhes do cupom</h1>
          <div
            className="d-flex align-items-center"
            style={{ gap: 'var(--space-8)' }}
          >
            <JdsButton variant="outlined" onClick={goToEdit}>
              Editar
            </JdsButton>
            <Dropdown alignRight>
              <Dropdown.Toggle
                as={JdsMoreToggle}
                variant="outlined"
                id="coupon-details-actions"
                aria-label="Abrir opções"
              />
              <Dropdown.Menu className="dropdown-menu-sm">
                <Dropdown.Item onClick={() => setConfirmAction('expire')}>
                  Expirar cupom
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => setConfirmAction('delete')}
                  style={{ color: 'var(--fg-error-strong)' }}
                >
                  Excluir cupom
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        <div>
          <DetailRow label="Status">
            <CouponStatusBadge coupon={coupon} />
          </DetailRow>
          <DetailRow label="Nome do cupom">{coupon.code}</DetailRow>
          <DetailRow label="Tipo">{CouponTypeLabels[coupon.type]}</DetailRow>
          {coupon.type === CouponTypeEnum.ENROLLMENT && (
            <DetailRow label="Duração do ciclo">
              {coupon.cycleDays} dias
            </DetailRow>
          )}
          <DetailRow label="Data de início">
            {formatDate(coupon.startsAt)}
          </DetailRow>
          <DetailRow label="Data de expiração">
            {formatDate(coupon.expiresAt)}
          </DetailRow>
          {(coupon.description || coupon.observation) && (
            <div style={{ padding: '10px 0' }}>
              <div style={{ color: '#838486', fontSize: '13px', marginBottom: '4px' }}>
                Observação
              </div>
              <div style={{ whiteSpace: 'pre-wrap' }}>{coupon.description || coupon.observation}</div>
            </div>
          )}
        </div>
      </div>

      <div className="jds-card mb-6">
        <h2 className="jds-title-md mb-4">Descontos</h2>
        <CouponDiscountsTable discounts={discounts} />
      </div>

      <div className="jds-card mb-6">
        <h2 className="jds-title-md mb-4">Histórico</h2>
        <div>
          <JdsTag label="Em breve" color="warning" />
          <div style={{ overflowX: 'auto', width: '100%' }}>
            <table className="table jds-table">
              <thead>
                <tr>
                  <th>Alterado por</th>
                  <th>E-mail</th>
                  <th>Alteração</th>
                  <th>Alterado em</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td colSpan={4} className="text-center text-muted">
                    Sem histórico disponível
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {confirmAction === 'expire' && (
        <ModalConfirm
          title="Expirar cupom"
          message="Tem certeza que deseja expirar este cupom? Ele deixará de ser aplicável."
          onConfirm={handleExpire}
          onClose={() => setConfirmAction(null)}
          isLoading={loading}
        />
      )}

      {confirmAction === 'delete' && (
        <ModalConfirm
          title="Excluir cupom"
          message="Tem certeza que deseja excluir este cupom? Esta ação não pode ser desfeita."
          onConfirm={handleDelete}
          onClose={() => setConfirmAction(null)}
          isLoading={loading}
        />
      )}
    </div>
  );
}
